import React, { useState, useRef, useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import '../settingscommon.scss';
import '../User/user.scss';
import '../EmailProvider/emailprovider.scss';
import { Link } from 'react-router-dom';
import { Editor } from '@tinymce/tinymce-react';
import { useMutation, useLazyQuery } from '@apollo/client';
import { CREATE_SIGNATURE, SIGNATURE_UPLOAD_FILE } from '../../../gql/signature/mutation'
import { GET_SIGNATURE } from '../../../gql/signature/queries';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useUnsavedChangeWarning from '../../../hooks/useUnsavedChangeWarning';
// import {IMAGE_URL} from '../../../configUrl';

function EmaiSignature() {
    const editorRef = useRef(null);
    const [Prompt, setIsDirty, setPristine] = useUnsavedChangeWarning()
    const [errorMessage, setErrorMessage] = useState('')
    const [initialData, setInitialData] = useState('')
    const [createdSignature, setCreatedSignature] = useState(false)
    const [createSignature, {loading}] = useMutation(CREATE_SIGNATURE, {
        onCompleted(data){
            setCreatedSignature(true)
        },
        onError(error){
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    })
    const [loadSignature] = useLazyQuery(GET_SIGNATURE, {
        onCompleted(data){
            if(data?.emailSignature?.signature){
                setInitialData(data.emailSignature.signature)
            }
        }
    })

    const [uploadFile] = useMutation(SIGNATURE_UPLOAD_FILE, {
        onError(error){
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    });

    useEffect(() => {
        loadSignature()
        // eslint-disable-next-line
    },[])
    
    const handleSave = () => {
        setPristine()
        let editorData;
        let fileArray = []
        if (editorRef.current) {
            editorData = editorRef.current.getContent() 

        }

        const tiny = window.frames[0].document.getElementById('tinymce').getElementsByClassName('selectedImage')
        for(var i of tiny){
            fileArray.push(i.src)
        }
    

        if(editorData){
            createSignature({
                variables: {
                    createEmailSignatureInput: {
                        signature: editorData,
                        media: fileArray
                    }
                }
            })
        }
    }

    const uploadImage = async (file) => {
        let returedData;
        if(file){
            returedData = await uploadFile({
                variables: {
                    file: file
                }
            })
        }
        if(returedData){
            if(returedData?.data?.uploadSignatureFile?.url){
                // const data = baseUrl+returedData.data.uploadProfileImage.new_file_key
                const data = returedData?.data?.uploadSignatureFile?.url
                return data
            }
        }
    }

    if(createdSignature){
        toast.success("Successfully Saved.", {
            position: "bottom-right",
            // closeOnClick: true,
            // autoClose: 1000,
        }) 
        setCreatedSignature(false)
    }

    if(errorMessage){
        toast.error(errorMessage, {
          position: "bottom-right",
          closeOnClick: true,
        })
        setErrorMessage('')
    }

    return <>
    <div>
        <h1 className='page-title'>Settings</h1>
        <Nav
            className='setting-menu'
        >
            <Nav.Item>
                <Link to="/settings/user" className='nav-link'>User</Link>
            </Nav.Item>
            <Nav.Item>
                <Link to="/settings/email-provider" className='nav-link'>Email Provider</Link>
            </Nav.Item>
            <Nav.Item>
                <Link to="/settings/text-provider" className='nav-link'>SMS Provider</Link>
            </Nav.Item>
            <Nav.Item>
                <Link to="/settings/email-signature" className='nav-link active'>Email Signature</Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Link to="/settings/billing" className='nav-link'>Billing</Link>
            </Nav.Item> */}
        </Nav>
        <div className='profile-sec email-signature'>
            <p className="btn_container_p">This signature will be used when you put &#123;&#123;signature&#125;&#125; custom variable in an email template.
                {
                    loading ?
                    <button className='solid-button'>Save &nbsp;
                     <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    </button>
                    :
                    <button className='solid-button' onClick={handleSave} >Save</button>
                }
            </p>
            <Editor
                apiKey="91q8iwhlpgvrqjo15jnx6nguiflh49gxd2sb9luqq4k9n5mi"
                onInit={(evt, editor) => editorRef.current = editor}
                initialValue={initialData ? initialData : "<p>Name | Title</p><p>Company</p><p>Address</p><p>Email | Website</p> <p>Feel Free To Connect With Me On LinkedIn :</p> <p>Linkedinurl</p>" }
                init={{
                    height: 331,
                    a11y_advanced_options: true, //new
                    paste_data_images: true, //new
                    selector: 'textarea',   //new
                    image_advtab: true, //new
                    // image_dimensions: false, //new
                    image_class_list: [    //new
                        {title: 'selectedImage', value: 'selectedImage'},
                      ],
                    content_style: 'img.selectedImage { border-radius: 50%; object-fit: cover;}',
                    menubar: false,
                    // menubar: 'table',
                    toolbar_location: 'bottom',
                    plugins: [
                        'advlist autolink lists link image',
                        'charmap print preview anchor help',
                        'searchreplace visualblocks code',
                        'insertdatetime media table paste wordcount',
                        'table'
                    ],
                    toolbar:
                        'undo redo forecolor backcolor | formatselect | fontselect | bold italic underline | link image | alignleft aligncenter alignright | bullist numlist outdent indent | table | help ',
                    image_title: true,
                    automatic_uploads: true,
                    file_picker_types: 'image',
                    /* and here's our custom image picker*/
                    file_picker_callback: function (cb, value, meta) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');
                        input.onchange = async function () {
                            var file = this.files[0];
                            const fileLink = await uploadImage(file)
                            var reader = new FileReader();
                            reader.onload = function () {
                                var id = 'blobid' + (new Date()).getTime();
                                var blobCache = window.tinymce.activeEditor.editorUpload.blobCache;
                                var base64 = reader.result.split(',')[1];
                                var blobInfo = blobCache.create(id, file, base64);
                                blobCache.add(blobInfo);
                                cb(fileLink, { title: file.name, id: "selectedImage" });
                            };
                            reader.readAsDataURL(file);
                        };
                        input.click();
                    },
                    // content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
                // onChange={handleEditorChange}
                onChange={() => setIsDirty()}
            />
        </div>
    </div>
    {Prompt}
    </>
}

export default EmaiSignature;
